import React from 'react';
import { Flex, Icon, Text } from '@chakra-ui/react';
import { TREND_ICONS } from './constants';

interface ComparisonSectionProps {
  trend?: string;
  trendColor?: string;
  percentageDiff?: number;
  comparisonLabel?: string;
  fontSize?: string;
}

export const ComparisonSection: React.FC<ComparisonSectionProps> = ({
  trend,
  trendColor,
  percentageDiff,
  comparisonLabel,
  fontSize,
}) => {
  const isNACase = comparisonLabel?.startsWith('NA -');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [naText, ...restLabel] = isNACase
    ? comparisonLabel.split('NA -')
    : ['', comparisonLabel];

  // Format comparison label to handle "vs" and time period better
  const formatComparisonLabel = (label: string) => {
    if (!label) return null;

    // Handle "vs" cases
    if (label.toLowerCase().includes('vs')) {
      const [first, ...rest] = label.split(/\s*vs\s*/i);
      return (
        <Flex gap="4px" flexWrap="wrap" overflow="hidden">
          <Text
            as="span"
            whiteSpace="nowrap"
            fontSize={fontSize}
            flexShrink={0}
            userSelect="none"
          >
            {first}
          </Text>
          <Text
            as="span"
            fontSize={fontSize}
            overflow="hidden"
            textOverflow="ellipsis"
            userSelect="none"
          >
            vs {rest.join(' ')}
          </Text>
        </Flex>
      );
    }

    return (
      <Text
        userSelect="none"
        fontSize={fontSize}
        overflow="hidden"
        textOverflow="ellipsis"
      >
        {label}
      </Text>
    );
  };

  return (
    <Flex
      gap="4px"
      align="center"
      flexWrap="wrap"
      width="100%"
      overflow="hidden"
    >
      {trend && percentageDiff !== 0 && (
        <Icon
          as={TREND_ICONS[trend]}
          color={trendColor}
          boxSize={fontSize}
          flexShrink={0}
        />
      )}
      {percentageDiff !== undefined && !isNaN(percentageDiff) ? (
        percentageDiff === 0 ? (
          <Text
            fontSize="sm"
            color="rgb(2, 122, 72)"
            whiteSpace="nowrap"
            flexShrink={0}
            userSelect="none"
          >
            Unchanged
          </Text>
        ) : (
          <Text
            fontSize="sm"
            color={trendColor}
            whiteSpace="nowrap"
            flexShrink={0}
            userSelect="none"
          >
            {Math.abs(percentageDiff)}%
          </Text>
        )
      ) : null}

      {comparisonLabel &&
        (isNACase ? (
          <Flex gap="4px" flexWrap="wrap" overflow="hidden">
            <Text
              as="span"
              fontWeight="semiBold"
              fontSize={fontSize}
              whiteSpace="nowrap"
              flexShrink={0}
              userSelect="none"
            >
              NA
            </Text>
            <Text
              as="span"
              fontSize={fontSize}
              overflow="hidden"
              textOverflow="ellipsis"
              userSelect="none"
            >
              - {restLabel.join(' ')}
            </Text>
          </Flex>
        ) : (
          formatComparisonLabel(comparisonLabel)
        ))}
    </Flex>
  );
};
